import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { withTranslation } from 'react-i18next';
import { phoneRegExp } from '../shared/constants/phoneRegExp';
import ReCAPTCHA from 'react-google-recaptcha';
import { Fade } from 'react-reveal';
import testimonialsData from '../shared/data/testimonialsData';
import Slider from 'react-slick';
import { Link } from 'react-scroll';
import { HashLink } from 'react-router-hash-link';
import { calendlyLink } from '../shared/constants/links';
import ClutchWidget from './ClutchWidget';
import Portfolio2griditem from './Portfolios/Portfolio2griditem';
import portfolioItems from '../shared/data/portfolioItems';
import getLocalizedPath from '../shared/functions/getLocalizedPath';

const URL = process.env.REACT_APP_SEND_MAIL_API_URL;
const RECAPTCHA_SITE_KEY = '6Le9NF4dAAAAAPKS-_1_3JMHSH2eJepm-bUwAZNH';

const subjects = {
  software: 'SOFTWARE_DEV_MAINTENANCE',
  nearshoring: 'NEARSHORE_CONSULTING',
};

const contactFormStates = {
  FORM_VISIBLE: 'FORM_VISIBLE',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

class ContactAiLanding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formState: contactFormStates.FORM_VISIBLE,
    };
    this.t = this.props.t;
    this.i18n = this.props.i18n;

    this.contactFormValidationSchema = Yup.object().shape({
      name: Yup.string(),
      email: Yup.string()
        .test('is-phone-filled', this.t('EITHER_PHONE_OR_EMAIL'), function (value) {
          const { phone } = this.parent;
          return !phone ? value != null : true;
        })
        .email(this.t('INVALID_EMAIL')),
      phone: Yup.string()
        .test('is-email-filled', this.t('EITHER_PHONE_OR_EMAIL'), function (value) {
          const { email } = this.parent;
          return !email ? value != null : true;
        })
        .matches(phoneRegExp, this.t('INVALID_PHONE')),
      subject: Yup.string(),
      message: Yup.string(),
    });

    this.initialValues = {
      name: '',
      email: '',
      phone: '',
      subject: (this.props.subject && this.t(subjects[this.props.subject])) || '',
      message: '',
      recaptcha: '',
    };

    this.reCaptchaRef = React.createRef();
  }

  handleSubmit(data) {
    const headers = {
      'Content-Type': 'application/json',
    };

    const params = {
      headers,
      method: 'POST',
      body: JSON.stringify(data),
    };

    fetch(`${URL}/send`, params)
      .then((response) => {
        this.setState({
          ...this.state,
          formState: response.ok ? contactFormStates.SUCCESS : contactFormStates.ERROR,
        });
      })
      .catch(() => {
        this.setState({ ...this.state, formState: contactFormStates.ERROR });
      });
  }

  handleBlur = (e, props) => {
    if (!props.values.recaptcha) {
      this.reCaptchaRef.current.execute();
      props.setSubmitting(true);
    }
    props.handleBlur(e);
  };

  render() {
    const t = this.t;

    const sliderSettings = {
      dots: false,
      infinite: true,
      speed: 500,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      centerMode: false,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    };

    return (
      <React.Fragment>
        <section className="contact_info_area sec_pad bg_color mt_60">
          <img className="banner_shap" src={require('../img/home4/banner_bg.png')} alt="" />
          <div className="container">
            <div className="row flex-row-reverse wrap-reverse">
              <div className="col-lg-6">
                <div className="seo_features_img">
                  <div className="business_card">
                    <a href=".#">
                      <h3 className="f_p f_size_16 f_600 t_color3">Aku Kajan</h3>
                    </a>
                    <h5>Commercial Director</h5>
                  </div>
                  <img src={require('../img/teams/aku-kajan-portrait-transparent.png')} alt="" />
                </div>
              </div>
              <div className="col-lg-6 ai-landing-left-column">
                <Fade bottom cascade>
                  <div className="seo_features_content">
                    <h1 className="f_700 t_color3 mb-30 wow fadeInLeft">{t('DO_YOU_NEED_AI_SPECIALISTS')}</h1>
                    <h5 className="l_height30 t_color3 f_300">{t('PLANNING_TO_DEVELOP_AN')}</h5>
                    <div className="media seo_features_item">
                      <div className="icon one">
                        <i className="icon-user-follow"></i>
                      </div>
                      <div className="media-body">
                        <h3>{t('AI_TEAM_EXTENSION')}</h3>
                        <p>{t('OUR_CONSULTANTS_INTEGRATE_INTO_TEAM_WITH_AI_EXPERTISE')}</p>
                      </div>
                    </div>
                    <div className="media seo_features_item">
                      <div className="icon two">
                        <i className="icon-settings"></i>
                      </div>
                      <div className="media-body">
                        <h3>{t('END_TO_END_AI_DELIVERY')}</h3>
                        <p>{t('FROM_MODEL_DESIGN')}</p>
                      </div>
                    </div>
                    <div className="cta-wrapper">
                      <div className="contact-us-button-container">
                        <Link
                          component="button"
                          to="contact-form"
                          spy={true}
                          smooth={true}
                          offset={-100}
                          duration={500}
                          className="btn_three contact_us_btn"
                        >
                          {t('CONTACT_US')}
                        </Link>

                        <button className="btn_three book_a_call_btn" onClick={() => window.open(calendlyLink)}>
                          {t('BOOK_A_CALL')}
                        </button>
                      </div>
                      <div className="see-sample-ai-projects d-block text-center">
                        <Link
                          className="d-inline-flex flex-column nav-link"
                          to="sample-ai-projects"
                          spy={true}
                          smooth={true}
                          offset={-50}
                          duration={500}
                        >
                          <span>{t('OR_SEE_SAMPLE_AI_PROJECTS_FIRST')}</span>
                          <i className="ti-angle-down" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </section>
        <section id="sample-ai-projects" className="contact_info_area py_50 bg_white">
          <div className="container">
            <h2 className="f_size_30 f_500 t_color3 l_height40 text-center mb_40">{t('SAMPLE_AI_PROJECTS')}</h2>
            <div className="row portfolio_gallery mb_30" id="work-portfolio">
              {portfolioItems
                .filter(({ projectType }) => projectType.includes('ai'))
                .slice(0, 2)
                .map(({ link, imgs, title, shortDescription, cssClass, id }) => (
                  <Portfolio2griditem
                    link={link}
                    colClass={`col-lg-6 ${cssClass}`}
                    pImg={imgs[0]}
                    ptitle={title}
                    tOne="Web"
                    key={id}
                    description={t(shortDescription)}
                  />
                ))}
            </div>
            <div className="col-lg-12 text-center mt_60">
              <HashLink
                to={getLocalizedPath({ i18n: this.i18n, path: '/portfolio?type=ai' })}
                className="seo_btn seo_btn_one btn_hover"
              >
                {t('SHOW_ALL_PROJECTS')}
              </HashLink>
            </div>
          </div>
        </section>
        <section className="contact_info_area py_50 bg_white">
          <div className="container">
            <h2 className="f_size_30 f_500 t_color3 l_height40 text-center mb_40">{t('OUR_TOP_TECHNOLOGIES')}</h2>
            <div className="contact_logos_container">
              <Slider className="testimonial_slider" {...sliderSettings}>
                <div className="tech-item">
                  <div className="icon" style={{ backgroundColor: '#F0DB4F' }}>
                    <svg viewBox="0 0 128 128">
                      <path
                        fill="#fff"
                        d="M2 1v125h125v-125h-125zm66.119 106.513c-1.845 3.749-5.367 6.212-9.448 7.401-6.271 1.44-12.269.619-16.731-2.059-2.986-1.832-5.318-4.652-6.901-7.901l9.52-5.83c.083.035.333.487.667 1.071 1.214 2.034 2.261 3.474 4.319 4.485 2.022.69 6.461 1.131 8.175-2.427 1.047-1.81.714-7.628.714-14.065-.001-10.115.046-20.188.046-30.188h11.709c0 11 .06 21.418 0 32.152.025 6.58.596 12.446-2.07 17.361zm48.574-3.308c-4.07 13.922-26.762 14.374-35.83 5.176-1.916-2.165-3.117-3.296-4.26-5.795 4.819-2.772 4.819-2.772 9.508-5.485 2.547 3.915 4.902 6.068 9.139 6.949 5.748.702 11.531-1.273 10.234-7.378-1.333-4.986-11.77-6.199-18.873-11.531-7.211-4.843-8.901-16.611-2.975-23.335 1.975-2.487 5.343-4.343 8.877-5.235l3.688-.477c7.081-.143 11.507 1.727 14.756 5.355.904.916 1.642 1.904 3.022 4.045-3.772 2.404-3.76 2.381-9.163 5.879-1.154-2.486-3.069-4.046-5.093-4.724-3.142-.952-7.104.083-7.926 3.403-.285 1.023-.226 1.975.227 3.665 1.273 2.903 5.545 4.165 9.377 5.926 11.031 4.474 14.756 9.271 15.672 14.981.882 4.916-.213 8.105-.38 8.581z"
                      ></path>
                    </svg>
                  </div>
                  <h3>JavaScript</h3>
                </div>
                <div className="tech-item">
                  <div className="icon" style={{ backgroundColor: '#007acc' }}>
                    <svg viewBox="0 0 128 128">
                      <path d="M1.5,63.91v62.5h125V1.41H1.5Zm100.73-5a15.56,15.56,0,0,1,7.82,4.5,20.58,20.58,0,0,1,3,4c0,.16-5.4,3.81-8.69,5.85-.12.08-.6-.44-1.13-1.23a7.09,7.09,0,0,0-5.87-3.53c-3.79-.26-6.23,1.73-6.21,5a4.58,4.58,0,0,0,.54,2.34c.83,1.73,2.38,2.76,7.24,4.86,8.95,3.85,12.78,6.39,15.16,10,2.66,4,3.25,10.46,1.45,15.24-2,5.2-6.9,8.73-13.83,9.9a38.32,38.32,0,0,1-9.52-.1,23,23,0,0,1-12.72-6.63c-1.15-1.27-3.39-4.58-3.25-4.82a9.34,9.34,0,0,1,1.15-.73L82,101l3.59-2.08.75,1.11a16.78,16.78,0,0,0,4.74,4.54c4,2.1,9.46,1.81,12.16-.62a5.43,5.43,0,0,0,.69-6.92c-1-1.39-3-2.56-8.59-5-6.45-2.78-9.23-4.5-11.77-7.24a16.48,16.48,0,0,1-3.43-6.25,25,25,0,0,1-.22-8c1.33-6.23,6-10.58,12.82-11.87A31.66,31.66,0,0,1,102.23,58.93ZM72.89,64.15l0,5.12H56.66V115.5H45.15V69.26H28.88v-5A49.19,49.19,0,0,1,29,59.09C29.08,59,39,59,51,59L72.83,59Z"></path>
                    </svg>
                  </div>
                  <h3>TypeScript</h3>
                </div>
                <div className="tech-item">
                  <div className="icon" style={{ backgroundColor: '#61DAFB' }}>
                    <svg viewBox="0 0 128 128">
                      <path d="M107.3 45.2c-2.2-.8-4.5-1.6-6.9-2.3.6-2.4 1.1-4.8 1.5-7.1 2.1-13.2-.2-22.5-6.6-26.1-1.9-1.1-4-1.6-6.4-1.6-7 0-15.9 5.2-24.9 13.9-9-8.7-17.9-13.9-24.9-13.9-2.4 0-4.5.5-6.4 1.6-6.4 3.7-8.7 13-6.6 26.1.4 2.3.9 4.7 1.5 7.1-2.4.7-4.7 1.4-6.9 2.3-12.5 4.8-19.3 11.4-19.3 18.8s6.9 14 19.3 18.8c2.2.8 4.5 1.6 6.9 2.3-.6 2.4-1.1 4.8-1.5 7.1-2.1 13.2.2 22.5 6.6 26.1 1.9 1.1 4 1.6 6.4 1.6 7.1 0 16-5.2 24.9-13.9 9 8.7 17.9 13.9 24.9 13.9 2.4 0 4.5-.5 6.4-1.6 6.4-3.7 8.7-13 6.6-26.1-.4-2.3-.9-4.7-1.5-7.1 2.4-.7 4.7-1.4 6.9-2.3 12.5-4.8 19.3-11.4 19.3-18.8s-6.8-14-19.3-18.8zm-14.8-30.5c4.1 2.4 5.5 9.8 3.8 20.3-.3 2.1-.8 4.3-1.4 6.6-5.2-1.2-10.7-2-16.5-2.5-3.4-4.8-6.9-9.1-10.4-13 7.4-7.3 14.9-12.3 21-12.3 1.3 0 2.5.3 3.5.9zm-11.2 59.3c-1.8 3.2-3.9 6.4-6.1 9.6-3.7.3-7.4.4-11.2.4-3.9 0-7.6-.1-11.2-.4-2.2-3.2-4.2-6.4-6-9.6-1.9-3.3-3.7-6.7-5.3-10 1.6-3.3 3.4-6.7 5.3-10 1.8-3.2 3.9-6.4 6.1-9.6 3.7-.3 7.4-.4 11.2-.4 3.9 0 7.6.1 11.2.4 2.2 3.2 4.2 6.4 6 9.6 1.9 3.3 3.7 6.7 5.3 10-1.7 3.3-3.4 6.6-5.3 10zm8.3-3.3c1.5 3.5 2.7 6.9 3.8 10.3-3.4.8-7 1.4-10.8 1.9 1.2-1.9 2.5-3.9 3.6-6 1.2-2.1 2.3-4.2 3.4-6.2zm-25.6 27.1c-2.4-2.6-4.7-5.4-6.9-8.3 2.3.1 4.6.2 6.9.2 2.3 0 4.6-.1 6.9-.2-2.2 2.9-4.5 5.7-6.9 8.3zm-18.6-15c-3.8-.5-7.4-1.1-10.8-1.9 1.1-3.3 2.3-6.8 3.8-10.3 1.1 2 2.2 4.1 3.4 6.1 1.2 2.2 2.4 4.1 3.6 6.1zm-7-25.5c-1.5-3.5-2.7-6.9-3.8-10.3 3.4-.8 7-1.4 10.8-1.9-1.2 1.9-2.5 3.9-3.6 6-1.2 2.1-2.3 4.2-3.4 6.2zm25.6-27.1c2.4 2.6 4.7 5.4 6.9 8.3-2.3-.1-4.6-.2-6.9-.2-2.3 0-4.6.1-6.9.2 2.2-2.9 4.5-5.7 6.9-8.3zm22.2 21l-3.6-6c3.8.5 7.4 1.1 10.8 1.9-1.1 3.3-2.3 6.8-3.8 10.3-1.1-2.1-2.2-4.2-3.4-6.2zm-54.5-16.2c-1.7-10.5-.3-17.9 3.8-20.3 1-.6 2.2-.9 3.5-.9 6 0 13.5 4.9 21 12.3-3.5 3.8-7 8.2-10.4 13-5.8.5-11.3 1.4-16.5 2.5-.6-2.3-1-4.5-1.4-6.6zm-24.7 29c0-4.7 5.7-9.7 15.7-13.4 2-.8 4.2-1.5 6.4-2.1 1.6 5 3.6 10.3 6 15.6-2.4 5.3-4.5 10.5-6 15.5-13.8-4-22.1-10-22.1-15.6zm28.5 49.3c-4.1-2.4-5.5-9.8-3.8-20.3.3-2.1.8-4.3 1.4-6.6 5.2 1.2 10.7 2 16.5 2.5 3.4 4.8 6.9 9.1 10.4 13-7.4 7.3-14.9 12.3-21 12.3-1.3 0-2.5-.3-3.5-.9zm60.8-20.3c1.7 10.5.3 17.9-3.8 20.3-1 .6-2.2.9-3.5.9-6 0-13.5-4.9-21-12.3 3.5-3.8 7-8.2 10.4-13 5.8-.5 11.3-1.4 16.5-2.5.6 2.3 1 4.5 1.4 6.6zm9-15.6c-2 .8-4.2 1.5-6.4 2.1-1.6-5-3.6-10.3-6-15.6 2.4-5.3 4.5-10.5 6-15.5 13.8 4 22.1 10 22.1 15.6 0 4.7-5.8 9.7-15.7 13.4z"></path>
                    </svg>
                  </div>
                  <h3>React</h3>
                </div>
                <div className="tech-item">
                  <div className="icon" style={{ backgroundColor: '#C4473A' }}>
                    <svg viewBox="0 0 128 128">
                      <path
                        fill="#fff"
                        d="M52.864 64h23.28l-12.375-25.877zM63.81 1.026l-59.257 20.854 9.363 77.637 49.957 27.457 50.214-27.828 9.36-77.635-59.637-20.485zm-15.766 73.974l-7.265 18.176-13.581.056 36.608-81.079-.07-.153h-.064l.001-.133.063.133h.14100000000000001l.123-.274v.274h-.124l-.069.153 38.189 81.417-13.074-.287-8.042-18.58-17.173.082"
                      ></path>
                    </svg>
                  </div>
                  <h3>Angular</h3>
                </div>
                <div className="tech-item">
                  <div className="icon" style={{ backgroundColor: '#FFD845' }}>
                    <svg viewBox="0 0 128 128">
                      <path
                        fill="#fff"
                        d="M49.33 62h29.159c8.117 0 14.511-6.868 14.511-15.019v-27.798c0-7.912-6.632-13.856-14.555-15.176-5.014-.835-10.195-1.215-15.187-1.191-4.99.023-9.612.448-13.805 1.191-12.355 2.181-14.453 6.751-14.453 15.176v10.817h29v4h-40.224000000000004c-8.484 0-15.914 5.108-18.237 14.811-2.681 11.12-2.8 17.919 0 29.53 2.075 8.642 7.03 14.659 15.515 14.659h9.946v-13.048c0-9.637 8.428-17.952 18.33-17.952zm-1.838-39.11c-3.026 0-5.478-2.479-5.478-5.545 0-3.079 2.451-5.581 5.478-5.581 3.015 0 5.479 2.502 5.479 5.581-.001 3.066-2.465 5.545-5.479 5.545zM122.281 48.811c-2.098-8.448-6.103-14.811-14.599-14.811h-10.682v12.981c0 10.05-8.794 18.019-18.511 18.019h-29.159c-7.988 0-14.33 7.326-14.33 15.326v27.8c0 7.91 6.745 12.564 14.462 14.834 9.242 2.717 17.994 3.208 29.051 0 7.349-2.129 14.487-6.411 14.487-14.834v-11.126h-29v-4h43.682c8.484 0 11.647-5.776 14.599-14.66 3.047-9.145 2.916-17.799 0-29.529zm-41.955 55.606c3.027 0 5.479 2.479 5.479 5.547 0 3.076-2.451 5.579-5.479 5.579-3.015 0-5.478-2.502-5.478-5.579 0-3.068 2.463-5.547 5.478-5.547z"
                      ></path>
                    </svg>
                  </div>
                  <h3>Python</h3>
                </div>
                <div className="tech-item">
                  <div className="icon" style={{ backgroundColor: '#F7A80D' }}>
                    <svg viewBox="0 0 128 128">
                      <path
                        fill="#fff"
                        d="M38.089 77.466l-11.4 4.896 10.559 4.514 12.241-4.514-11.4-4.896zm-17.138 6.12l-.382 22.034 16.679 7.345V90.089l-16.297-6.503zm34.276 0l-15.073 5.739V110.9l15.073-6.121V83.586zm17.979-68.551L61.73 19.931l10.635 4.515 12.241-4.515-11.4-4.896zm-15.914 6.503v22.034l14.231 4.132.459-20.046-14.69-6.12zm31.828 1.224L75.654 28.5v21.652l13.466-6.121V22.762zM19.306 46.047L7.907 50.944l10.558 4.514 12.241-4.514-11.4-4.897zM2.168 52.168l-.382 22.034 16.679 7.345V58.671L2.168 52.168zm34.275 0l-15.071 5.738V79.48l15.071-6.12V52.168zm19.587-6.937l-11.4 4.897 10.558 4.514 12.241-4.514-11.399-4.897zm-17.137 6.121l-.383 22.035 16.679 7.345V57.855l-16.296-6.503zm34.275 0L58.096 57.09v21.576l15.072-6.121V51.352zm35.908-36.317l-11.399 4.896 10.559 4.515 12.241-4.515-11.401-4.896zm-17.137 6.121l-.382 22.034 16.679 7.344V27.658l-16.297-6.502zm34.275 0l-15.071 5.738v21.575l15.071-6.12V21.156z"
                      ></path>
                    </svg>
                  </div>
                  <h3>AWS</h3>
                </div>
                <div className="tech-item">
                  <div className="icon" style={{ backgroundColor: '#1384C8' }}>
                    <svg viewBox="0 0 128 128">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        fill="#fff"
                        d="M82.108 78.432c.479-1.232 1.022-2.445 1.427-3.701 2.288-7.097 4.554-14.2 6.805-21.309.865-2.731 1.813-5.42 3.515-7.767 2.692-3.709 6.442-5.652 10.88-6.331a37.456 37.456 0 015.28-.406c5.267-.05 10.536-.015 15.804-.01.28 0 .56.029.957.052-.129.304-.199.525-.311.724-1.955 3.494-3.872 7.009-5.885 10.468-3.505 6.022-7.016 12.042-10.631 17.998-2.319 3.819-4.834 7.52-7.687 10.974-2.105 2.548-4.321 4.984-7.146 6.77-1.925 1.217-3.981 1.929-6.315 1.917-8.278-.045-16.556-.012-24.834-.024-2.461-.004-4.568-.941-6.356-2.603-2.563-2.381-4.093-5.412-5.345-8.608-2.284-5.835-3.563-11.951-5.031-18.014-.688-2.838-1.47-5.654-2.215-8.478-.048-.183-.142-.354-.25-.617l-.577.542c-3.228 3.207-6.071 6.741-8.615 10.498-.693 1.024-.926 2.374-1.313 3.591-1.424 4.47-2.722 8.983-4.264 13.411-1.477 4.242-4.125 7.616-8.264 9.61a18.565 18.565 0 01-7.689 1.855c-3.98.088-7.962.098-11.943.134-.952.009-.996-.069-.748-.99 1.707-6.338 3.87-12.514 6.58-18.492 2.794-6.167 6.085-12.048 10.231-17.419 2.823-3.657 5.941-7.031 9.843-9.582 1.979-1.293 4.083-2.315 6.477-2.584.394-.045.793-.073 1.189-.073 8.478-.004 16.956.082 25.433-.039 4.547-.065 7.839 1.855 10.304 5.515 1.533 2.276 2.63 4.761 3.553 7.328 1.861 5.178 3.018 10.547 4.325 15.878.748 3.051 1.581 6.081 2.379 9.12.06.228.157.446.238.668l.199-.006z"
                      ></path>
                    </svg>
                  </div>
                  <h3>C#/.NET</h3>
                </div>
                <div className="tech-item">
                  <div className="icon" style={{ backgroundColor: '#ea4535' }}>
                    <svg viewBox="0 0 128 128">
                      <g fill="#fff">
                        <path d="M80.6 40.3h.4l-.2-.2 14-14v-.3c-11.8-10.4-28.1-14-43.2-9.5C36.5 20.8 24.9 32.8 20.7 48c.2-.1.5-.2.8-.2 5.2-3.4 11.4-5.4 17.9-5.4 2.2 0 4.3.2 6.4.6.1-.1.2-.1.3-.1 9-9.9 24.2-11.1 34.6-2.6h-.1z"></path>
                        <path d="M108.1 47.8c-2.3-8.5-7.1-16.2-13.8-22.1L80 39.9c6 4.9 9.5 12.3 9.3 20v2.5c16.9 0 16.9 25.2 0 25.2H63.9v20h-.1l.1.2h25.4c14.6.1 27.5-9.3 31.8-23.1 4.3-13.8-1-28.8-13-36.9z"></path>
                        <path d="M39 107.9h26.3V87.7H39c-1.9 0-3.7-.4-5.4-1.1l-15.2 14.6v.2c6 4.3 13.2 6.6 20.7 6.6z"></path>
                        <path d="M40.2 41.9c-14.9.1-28.1 9.3-32.9 22.8-4.8 13.6 0 28.5 11.8 37.3l15.6-14.9c-8.6-3.7-10.6-14.5-4-20.8 6.6-6.4 17.8-4.4 21.7 3.8L68 55.2C61.4 46.9 51.1 42 40.2 42.1z"></path>
                      </g>
                    </svg>
                  </div>
                  <h3>Google Cloud</h3>
                </div>
                <div className="tech-item">
                  <div className="icon" style={{ backgroundColor: '#0089d6' }}>
                    <svg viewBox="0 0 128 128">
                      <path
                        fill="#fff"
                        d="M43.983 4.653a5.911 5.911 0 015.6 4.022l35.91 106.396a5.911 5.911 0 01-5.603 7.802h41.38a5.917 5.917 0 004.8-2.465 5.909 5.909 0 00.798-5.34L90.961 8.672a5.91 5.91 0 00-5.602-4.022zm-1.336.478a5.92 5.92 0 00-5.61 4.029L1.132 115.55a5.91 5.91 0 005.6 7.8h28.893c1.239 0 2.446-.41 3.452-1.113a5.923 5.923 0 002.157-2.916l7.019-20.71-13.411-12.857c-.246-.273-1.353-2.274-.369-4.002 1.108-1.659 2.955-1.659 2.955-1.659h17.285l9.074-26.145L48.274 8.321c-.042-.205-.914-1.365-2.281-2.28-1.37-.915-3.345-.909-3.345-.909zm-4.88 75.74a2.724 2.724 0 00-1.86 4.718l37.83 35.31c1.101 1.03 2.502 1.631 4.007 1.631 0 0 1.282.068 2.055-.033 1.817-.273 3.525-1.768 4.09-2.39 1.457-1.939.794-4.95.794-4.95l-11.45-34.28z"
                      ></path>
                    </svg>
                  </div>
                  <h3>Azure</h3>
                </div>
                <div className="tech-item">
                  <div className="icon" style={{ backgroundColor: '#83CD29' }}>
                    <svg viewBox="0 0 128 128">
                      <path
                        fill="#fff"
                        d="M112.771 30.334L68.674 4.729c-2.781-1.584-6.402-1.584-9.205 0L14.901 30.334C12.031 31.985 10 35.088 10 38.407v51.142c0 3.319 2.084 6.423 4.954 8.083l11.775 6.688c5.628 2.772 7.617 2.772 10.178 2.772 8.333 0 13.093-5.039 13.093-13.828v-50.49c0-.713-.371-1.774-1.071-1.774h-5.623C42.594 41 41 42.061 41 42.773v50.49c0 3.896-3.524 7.773-10.11 4.48L18.723 90.73c-.424-.23-.723-.693-.723-1.181V38.407c0-.482.555-.966.982-1.213l44.424-25.561c.415-.235 1.025-.235 1.439 0l43.882 25.555c.42.253.272.722.272 1.219v51.142c0 .488.183.963-.232 1.198l-44.086 25.576c-.378.227-.847.227-1.261 0l-11.307-6.749c-.341-.198-.746-.269-1.073-.086-3.146 1.783-3.726 2.02-6.677 3.043-.726.253-1.797.692.41 1.929l14.798 8.754a9.294 9.294 0 004.647 1.246c1.642 0 3.25-.426 4.667-1.246l43.885-25.582c2.87-1.672 4.23-4.764 4.23-8.083V38.407c0-3.319-1.36-6.414-4.229-8.073zM77.91 81.445c-11.726 0-14.309-3.235-15.17-9.066-.1-.628-.633-1.379-1.272-1.379h-5.731c-.709 0-1.279.86-1.279 1.566 0 7.466 4.059 16.512 23.453 16.512 14.039 0 22.088-5.455 22.088-15.109 0-9.572-6.467-12.084-20.082-13.886-13.762-1.819-15.16-2.738-15.16-5.962 0-2.658 1.184-6.203 11.374-6.203 9.105 0 12.461 1.954 13.842 8.091.118.577.645.991 1.24.991h5.754c.354 0 .692-.143.94-.396.24-.272.367-.613.335-.979-.891-10.568-7.912-15.493-22.112-15.493-12.631 0-20.166 5.334-20.166 14.275 0 9.698 7.497 12.378 19.622 13.577 14.505 1.422 15.633 3.542 15.633 6.395 0 4.955-3.978 7.066-13.309 7.066z"
                      ></path>
                    </svg>
                  </div>
                  <h3>Node.js</h3>
                </div>
                <div className="tech-item">
                  <div className="icon" style={{ backgroundColor: '#EA2D2E' }}>
                    <svg viewBox="0 0 128 128">
                      <path
                        fill="#fff"
                        d="M47.617 98.12c-19.192 5.362 11.677 16.439 36.115 5.969-4.003-1.556-6.874-3.351-6.874-3.351-10.897 2.06-15.952 2.222-25.844 1.092-8.164-.935-3.397-3.71-3.397-3.71zm33.189-10.46c-14.444 2.779-22.787 2.69-33.354 1.6-8.171-.845-2.822-4.805-2.822-4.805-21.137 7.016 11.767 14.977 41.309 6.336-3.14-1.106-5.133-3.131-5.133-3.131zm11.319-60.575c.001 0-42.731 10.669-22.323 34.187 6.024 6.935-1.58 13.17-1.58 13.17s15.289-7.891 8.269-17.777c-6.559-9.215-11.587-13.793 15.634-29.58zm9.998 81.144s3.529 2.91-3.888 5.159c-14.102 4.272-58.706 5.56-71.095.171-4.45-1.938 3.899-4.625 6.526-5.192 2.739-.593 4.303-.485 4.303-.485-4.952-3.487-32.013 6.85-13.742 9.815 49.821 8.076 90.817-3.637 77.896-9.468zM85 77.896c2.395-1.634 5.703-3.053 5.703-3.053s-9.424 1.685-18.813 2.474c-11.494.964-23.823 1.154-30.012.326-14.652-1.959 8.033-7.348 8.033-7.348s-8.812-.596-19.644 4.644C17.455 81.134 61.958 83.958 85 77.896zm5.609 15.145c-.108.29-.468.616-.468.616 31.273-8.221 19.775-28.979 4.822-23.725-1.312.464-2 1.543-2 1.543s.829-.334 2.678-.72c7.559-1.575 18.389 10.119-5.032 22.286zM64.181 70.069c-4.614-10.429-20.26-19.553.007-35.559C89.459 14.563 76.492 1.587 76.492 1.587c5.23 20.608-18.451 26.833-26.999 39.667-5.821 8.745 2.857 18.142 14.688 28.815zm27.274 51.748c-19.187 3.612-42.854 3.191-56.887.874 0 0 2.874 2.38 17.646 3.331 22.476 1.437 57-.8 57.816-11.436.001 0-1.57 4.032-18.575 7.231z"
                      ></path>
                    </svg>
                  </div>
                  <h3>Java</h3>
                </div>
                <div className="tech-item">
                  <div className="icon" style={{ backgroundColor: '#019BC6' }}>
                    <svg viewBox="0 0 128 128">
                      <path d="M124.8 52.1c-4.3-2.5-10-2.8-14.8-1.4-.6-5.2-4-9.7-8-12.9l-1.6-1.3-1.4 1.6c-2.7 3.1-3.5 8.3-3.1 12.3.3 2.9 1.2 5.9 3 8.3-1.4.8-2.9 1.9-4.3 2.4-2.8 1-5.9 2-8.9 2h-6.7v-14.1h-13v-25h-15v12h-25v13h-13v14h-11.2l-.2 1.5c-.5 6.4.3 12.6 3 18.5l1.1 2.2.1.2c7.9 13.4 21.7 19 36.8 19 29.2 0 53.3-13.1 64.3-40.6 7.4.4 15-1.8 18.6-8.9l.9-1.8-1.6-1zm-96.8-13.1h10v11h-10v-11zm13.1 44.2c0 1.7-1.4 3.1-3.1 3.1-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1 1.7.1 3.1 1.4 3.1 3.1zm-13.1-31.2h10v11h-10v-11zm-13 0h11v11h-11v-11zm27.7 50.2c-15.8-.1-24.3-5.4-31.3-12.4 2.1.1 4.1.2 5.9.2 1.6 0 3.2 0 4.7-.1 3.9-.2 7.3-.7 10.1-1.5 2.3 5.3 6.5 10.2 14 13.8h-3.4zm8.3-39.2h-11v-11h11v11zm0-13h-11v-11h11v11zm13 13h-11v-11h11v11zm0-13h-11v-11h11v11zm0-13h-11v-11h11v11zm13 26h-11v-11h11v11zM38.8 81.2c-.2-.1-.5-.2-.8-.2-1.2 0-2.2 1-2.2 2.2 0 1.2 1 2.2 2.2 2.2s2.2-1 2.2-2.2c0-.3-.1-.6-.2-.8-.2.3-.4.5-.8.5-.5 0-.9-.4-.9-.9.1-.4.3-.7.5-.8z"></path>
                    </svg>
                  </div>
                  <h3>Docker</h3>
                </div>
              </Slider>
            </div>
          </div>
        </section>
        <section className="contact_info_area sec_pad bg_color py_70" id="contact-form">
          <div className="container">
            <div className="row">
              <div className="col-lg-3">
                <div className="contact_info_item">
                  <h6 className="f_p f_size_20 t_color3 f_500 mb_20">{t('OFFICE_ADDRESS')}</h6>
                  <p className="f_400 f_size_15">
                    ul. Sienkiewicza 85/87, floor 11th
                    <br />
                    90-318 Łódź, Poland
                  </p>
                </div>
                <div className="contact_info_item">
                  <h6 className="f_p f_size_20 t_color3 f_500 mb_20">{t('CONTACT_INFO')}</h6>
                  <p className="f_400 f_size_15">
                    <span className="f_400 t_color3">Sales, Aku Kajan</span>{' '}
                    <a href="tel:358453216766">(+358) 45 321 6766</a>
                  </p>
                  <p className="f_400 f_size_15">
                    <span className="f_400 t_color3">{t('EMAIL')}:</span>{' '}
                    <a href="mailto:aku.kajan@polarnightsoftware.com">aku.kajan@polarnightsoftware.com</a>
                  </p>
                  <p className="f_400 f_size_15">
                    <span className="f_400 t_color3">{t('CONTACT')}</span>{' '}
                    <a href="tel:48731407479">(+48) 731 407 479</a>
                  </p>
                  <p className="f_400 f_size_15">
                    <span className="f_400 t_color3">{t('EMAIL')}:</span>{' '}
                    <a href="mailto:contact@polarnightsoftware.com">contact@polarnightsoftware.com</a>
                  </p>
                </div>
              </div>
              <div className="contact_form col-lg-9">
                <h2 className="f_p f_size_22 t_color3 f_600 l_height28 mb_20">{t('INTERESTED')}</h2>
                {this.state.formState === contactFormStates.FORM_VISIBLE && (
                  <Formik
                    initialValues={this.initialValues}
                    onSubmit={this.handleSubmit.bind(this)}
                    validateOnChange={false}
                    validateOnBlur={false}
                    validationSchema={this.contactFormValidationSchema}
                  >
                    {(props) => (
                      <Form className="contact_form_box" id="contactForm">
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="form-group text_box">
                              <Field
                                type="text"
                                name="email"
                                id="email"
                                placeholder={t('YOUR_EMAIL')}
                                onBlur={(e) => this.handleBlur(e, props)}
                              />
                              <ErrorMessage name="email">
                                {(message) => <p className="error">{message}</p>}
                              </ErrorMessage>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group text_box">
                              <Field
                                type="text"
                                name="phone"
                                id="phone"
                                placeholder={t('YOUR_PHONE')}
                                onBlur={(e) => this.handleBlur(e, props)}
                              />
                              <ErrorMessage name="phone">
                                {(message) => <p className="error">{message}</p>}
                              </ErrorMessage>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group text_box">
                              <Field
                                component="textarea"
                                name="message"
                                id="message"
                                cols="30"
                                rows="10"
                                placeholder={t('ENTER_YOUR_MESSAGE')}
                                onBlur={(e) => this.handleBlur(e, props)}
                              />
                              <ErrorMessage name="message">
                                {(message) => <p className="error">{message}</p>}
                              </ErrorMessage>
                            </div>
                          </div>
                        </div>
                        <ReCAPTCHA
                          ref={this.reCaptchaRef}
                          sitekey={RECAPTCHA_SITE_KEY}
                          size="invisible"
                          onChange={(value) => {
                            props.setFieldValue('recaptcha', value);
                            props.setSubmitting(false);
                          }}
                        />
                        <button
                          type="submit"
                          className="btn_three"
                          disabled={props.isSubmitting}
                          id="send-message-button"
                        >
                          {t('SEND_MESSAGE')}
                        </button>
                      </Form>
                    )}
                  </Formik>
                )}
                {this.state.formState === contactFormStates.SUCCESS && (
                  <div id="success">{t('MESSAGE_SUCCESSFULLY_SENT')}</div>
                )}
                {this.state.formState === contactFormStates.ERROR && (
                  <div id="error">
                    {t('SOMETHING_WENT_WRONG')}&nbsp;
                    <span
                      className="try_again"
                      onClick={() => {
                        this.setState({
                          ...this.state,
                          formState: contactFormStates.FORM_VISIBLE,
                        });
                      }}
                    >
                      {t('TRY_AGAIN')}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        <section className="contact_info_area py_40">
          <div className="container">
            <h2 className="f_size_30 f_500 t_color3 l_height40 text-center mb_40">{t('OUR_CUSTOMERS')}</h2>
            <div className="contact_logos_container">
              <Slider className="testimonial_slider" {...sliderSettings}>
                {testimonialsData
                  .filter((testimonial) => ![5, 6, 8].includes(testimonial.id))
                  .map((testimonial) => {
                    return (
                      <div className="logo_img">
                        <img src={require('../img/testimonials/' + testimonial.image)} alt="" />
                      </div>
                    );
                  })}
              </Slider>
            </div>
          </div>
        </section>
        <ClutchWidget />
      </React.Fragment>
    );
  }
}

export default withTranslation()(ContactAiLanding);
